import { render, staticRenderFns } from "./buyerAuthInfoDetail.vue?vue&type=template&id=832cb43a&"
import script from "./buyerAuthInfoDetail.vue?vue&type=script&lang=js&"
export * from "./buyerAuthInfoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports